import { HistoricalValuesPeriodTypes } from 'types/patient/types'

export const PATIENT_LIST = (professionalId: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/professional-patients-list/${professionalId}`

export const SEARCH_PATIENT_BY_CPF = (cpf: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/patient-to-add/${cpf}`

export const PATIENT_PROFESSIONAL_RELATION = `${import.meta.env.VITE_API_BASE_URL}/patient-professional-relation`

export const PATIENT_REGISTRATION_BASE = `${import.meta.env.VITE_API_BASE_URL}/v2/patient-registration`

export const PATIENT_REGISTRATION = (patientId: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/patient-registration/${patientId}`

export const PATIENT_CALCULATIONS = (patientId: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/patient-calculations/${patientId}`

export const PATIENT_VITAL_SIGNS = (patientId: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/patient-vital-signs/${patientId}`

export const PATIENT_MEDICAL_INFO = (patientId: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/patient-medical-information/${patientId}`

export const PATIENT_HISTORICAL_VALUES = (
  patientId: string,
  dataType: string,
  period: HistoricalValuesPeriodTypes
) =>
  `${import.meta.env.VITE_API_BASE_URL}/historical-values/${patientId}/${dataType}/${period}`
